import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import MultiSelect from "./multiSelect.js";

function mapStateToProps(state) {
  return {
    domainDetails: state.domainDetails,
    searchObj: state.searchObj,
    texts: state.translatedTexts,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(MultiSelect);
